export default __webpack_public_path__ + "static/media/ringoffire.00e08edb.png";